// frontend/src/api/news.js
// Role: Defines API call functions for news operations

const API_BASE_URL = 'https://addfly.me';
// const API_BASE_URL = 'http://localhost:8000';

export async function fetchLatestNews() {
  try {
    const response = await fetch(`${API_BASE_URL}/api/news/latest`);
    if (!response.ok) {
      throw new Error('Failed to fetch latest news');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching latest news:', error);
    throw error;
  }
}

export async function fetchNewsByDate(date) {
  try {
    const response = await fetch(`${API_BASE_URL}/api/news/date/${date}`);
    if (!response.ok) {
      throw new Error('Failed to fetch news for date');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching news by date:', error);
    throw error;
  }
} 
